
import Vue from 'vue'
import { IFilter } from '../store/state'
import VDatePicker from 'v-calendar'

interface IRangeConfig {
    start: {
        timeAdjust: string
    }
    end: {
        timeAdjust: string
    }
}

interface FilterData {
    dateRange: any
    modelConfig: IRangeConfig
}

interface FilterMethods {
    consoleLog(): void
    setFilter(filter: IFilter): void
    clearFilter(): void
    search(): void
}

interface FilterComputed {
    showFilter: boolean
    filters: IFilter[]
}

interface FilterProps {
    showDateFilter: boolean
}

Vue.use(VDatePicker)

export default Vue.extend<FilterData, FilterMethods, FilterComputed, FilterProps>({
	name: 'FilterWithSearch',
    props: {
        showDateFilter: () => true
    },
    data() {
        return {
            dateRange: null,
            modelConfig: {
                start: {
                    timeAdjust: '00:00:00',
                },
                end: {
                    timeAdjust: '23:59:59',
                },
            }
        }
    },
	computed: {
        showFilter() {
            return this.$store.getters.showFilter
        },
        filters() {
            const groupedFilters : any[] = [];
            let group : IFilter[] = [];
            this.$store.state.filters.forEach((filter: IFilter, index: number) => {
                group.push(filter);

                if ((index + 1) % 6 === 0 || index === this.$store.state.filters.length - 1) {
                    groupedFilters.push(group);
                    group = [];
                }
            })
            return groupedFilters
        }
    },
    watch: {
        dateRange(newValue) {
            this.$store.dispatch({
                type: 'setRangeFilter',
                payload: newValue
            })
        },
    },
	methods: {
        consoleLog() {
            this.$store.state.filters.forEach((element: any) => {
                if(element.current) {
                    console.log(element)
                }
            });
        },
        clearFilter() {
            this.dateRange = null
            this.$store.dispatch({
                type: 'clearFilter',
                payload: null
            })
        },
        setFilter(filter: IFilter) {
            this.$store.dispatch({
                type: 'setFilter',
                payload: filter
            })  
        },
		search() {
			this.$store.dispatch({
				type: 'search',
				payload: true
			})
		}
    },
	components: {}
})
